import startCase from 'lodash/startCase';
import toLower from 'lodash/toLower';

import { type ColorSet, Tag } from '@spotify-internal/encore-web';

const SUCCESS_STATES = new Set([
  'active',
  'live',
  'completed',
  'allocated',
  'ok',
]);
const WARNING_STATES = new Set([
  'draft',
  'pending',
  'running',
  'unallocated',
  'in_review',
]);
const DANGER_STATES = new Set(['aborted', 'failed', 'error', 'rejected']);

const normalizeState = (state: string) =>
  state.replace(/^STATE_/, '').toLowerCase();

const getColorSet = (state: string): ColorSet | undefined => {
  const normalized = normalizeState(state);
  if (SUCCESS_STATES.has(normalized)) return 'positiveSubdued';
  if (WARNING_STATES.has(normalized)) return 'warningSubdued';
  if (DANGER_STATES.has(normalized)) return 'negativeSubdued';
  return undefined;
};

interface StateTagProps {
  state: string;
}

export const StateTag = ({ state }: StateTagProps) => {
  const label = startCase(toLower(state));
  return (
    <Tag colorSet={getColorSet(state)} aria-label={label}>
      {label}
    </Tag>
  );
};
